/* globals console, module, require, window */
/* jshint esversion:6, globalstrict:true */
/* jscs:disable disallowDanglingUnderscores */

'use strict';
const _ = require('lodash'),
    json = require('./configuration.json'),
    types = {
        apiUrlBase: 'string',
        assetBase: 'string',
        // assetsBase: 'string', // assetBase should probably be assetsBase
        defaultHostContext: 'string',
        debounceInterval: 'integer',
        disableAnalytics: 'boolean',
        disabledViews: {
            console: 'boolean',
            contexts: 'boolean',
            programSummaryImage: 'boolean',
            programsMap: 'boolean',
            programDetailsMap: 'boolean',
            programSummaryMap: 'boolean'
        },
        embedded: 'boolean',
        tableEditButtonStyle: 'string',
        geolocation: 'string',
        geolocations: 'object',
        gaClientId: 'string',
        measurementId: 'string',
        gaBaseRoute: 'string',
        googleApiKey: 'string',
        hostContexts: 'object',
        mapStart: {
            latitude: 'float',
            longitude: 'float'
        },
        mapBase: 'string',
        mockdata: {
            enumerations: 'boolean',
            organizations: 'boolean',
            programs: 'boolean',
            tips: 'boolean',
            units: 'boolean',
            walkscore: 'boolean'
        },
        onerrorAlerts: 'boolean',
        mobileWidth: 'integer',
        tipaudit: 'boolean',
        useGeolocation: 'boolean'
    };
let configuration = {
        apiUrlBase: 'set via configuration.json',
        assetBase: 'assets/',
        // assetsBase: 'assets/', // assetBase should probably be assetsBase
        defaultHostContext: '',
        debounceInterval: 500,
        disableAnalytics: false,
        tableEditButtonStyle: 'text',
        _embedded: true,
        geolocation: '',
        geolocations: {},
        gaClientId: 'UA-6354151-13',
        gaBaseRoute: '/places',
        googleApiKey: 'set via configuration.json',
        hostContexts: {},
        mapBase: 'set via configuration.json',
        mapStart: {
            latitude: 46.7833333,
            longitude: -92.1063889
        },
        mobileWidth: 768,
        mockdata: {
            enumerations: false,
            organizations: false,
            programs: false,
            tips: false,
            units: false,
            walkscore: false
        },
        onerrorAlerts: false,
        tipaudit: false,
        useGeolocation: true
    };

configuration = _.merge(configuration, json);

_.each(window.location.search.substr(1).split('&'), function (s) {
    const a = s.split('='),
        path = a[0],
        value = a[1];
    if (_.has(configuration, path)) {
        if (_.get(types, path) === 'boolean') {
            _.set(configuration, path, value === undefined ? true : value === 'true');
        } else if (value) {
            // allow == cast on next line
            _.set(configuration, path, (value == +value) ? +value : value); // jshint ignore:line
        } else {
            _.set(configuration, path, true);
        }
    }
});

// console.log('configuration - %s', JSON.stringify(configuration));

module.exports = configuration;
